import React from 'react';
import useProfile from 'features/feature_user/hooks/UseProfile';

const ApplicationReview = ({ job, data, onBack, onSubmit, submitting }) => {
  const { data: profile } = useProfile();

  const fullName = `${profile?.first_name ?? ''} ${profile?.last_name ?? ''}`.trim();
  const email = profile?.email ?? '';
  const city = profile?.city ?? '';
  const country = profile?.country?.name ?? '';
  const phone = profile?.phone_number ?? '';

  return (
    <div className="card-style-1">
      <div className="mb-30">
        <h6 className="color-brand-1">Review your application</h6>
        <p className="text-muted">You are applying for: <strong>{job?.title}</strong></p>
      </div>

      <div className="mb-30">
        <h6 className="mb-15">Contact information</h6>
        <ul className="list-unstyled text-small">
          <li><strong>Full name:</strong> {fullName || '-'}</li>
          <li><strong>Email address:</strong> {email || '-'}</li>
          <li><strong>City:</strong> {city || '-'}</li>
          <li><strong>Country:</strong> {country || '-'}</li>
          <li><strong>Phone number:</strong> {phone || '-'}</li>
        </ul>
      </div>

      <div className="mb-30">
        <h6 className="mb-15">Application details</h6>
        <ul className="list-unstyled text-small">
          <li><strong>CV:</strong> {data?.cv?.type === 'cv' ? (data?.cv?.data?.title || `CV #${data?.cv?.data?.id}`) : (data?.cv?.data?.title || data?.cv?.data?.name || `My CV #${data?.cv?.data?.id}`)}</li>
          {data?.cover_letter && (
            <li><strong>Cover letter:</strong><br /> <span className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>{data.cover_letter}</span></li>
          )}
          {data?.relocation && <li><strong>Relocation:</strong> {data.relocation}</li>}
          {data?.title && <li><strong>Job Title:</strong> {data.title}</li>}
          {data?.company_title && <li><strong>Company:</strong> {data.company_title}</li>}
        </ul>
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-border" onClick={onBack} disabled={submitting}>
          Back
        </button>
        <button type="button" className="btn btn-default" onClick={onSubmit} disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit your application'}
        </button>
      </div>
    </div>
  );
};

export default ApplicationReview;


